"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toPascalCase = toPascalCase;
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.string.replace.js");
// 改写大驼峰：close-fill -> CloseFill
/*
以下为测试的内容
const test1 = 'edit';
const test2 = 'edit2';
const test3 = 'edit-24';
const test4 = 'edit-fill';
const test5 = 'edit-fill2';
const test6 = 'edit-fill-24';
const test7 = 'Edit';
const test8 = 'editFill';
const test9 = 'editFill-test';

console.log(test1, toPascalCase(test1));
console.log(test2, toPascalCase(test2));
console.log(test3, toPascalCase(test3));
console.log(test4, toPascalCase(test4));
console.log(test5, toPascalCase(test5));
console.log(test6, toPascalCase(test6));
console.log(test7, toPascalCase(test7));
console.log(test8, toPascalCase(test8));
console.log(test9, toPascalCase(test9));
*/
function toPascalCase(str) {
  return str.split('-').map(function (item) {
    var temp = item.replace(/^([a-z])/, function (x) {
      return x.toUpperCase();
    });
    return temp;
  }).join('');
}